import { SkillResponse } from './skillresponse';

export class VerticalSkillRespose {
    public verticalName: string = '';
    public skillResponses: SkillResponse[] = [];
}